import React from "react";
import { Translate } from "../../i18n/LanguageProvider";
import GatsbyHero from "gatsby-background-image";

const SectionHeroImage = ({
  image,
  sizeClass = "is-large",
  titleTranslationKey,
  subtitleTranslationKey,
}) => {
  return (
    <GatsbyHero
      fluid={image}
      className={`hero ${sizeClass} is-bold`}
      Tag="section"
    >
      <div className="hero-head"></div>
      <div className="hero-body">
        <div className="container has-text-centered">
          <div>
            {titleTranslationKey && (
              <h1 className="title is-1 is-inverted">
                <Translate>{titleTranslationKey}</Translate>
              </h1>
            )}
            {subtitleTranslationKey && (
              <h2 className="subtitle is-2 is-inverted">
                <Translate>{subtitleTranslationKey}</Translate>
              </h2>
            )}
          </div>
        </div>
      </div>
      {/*safetyBadges.covidBadge && (
        <Link to="/covid-info">
          <Image
            className="safety-badge"
            fluid={safetyBadges.covidBadge.childImageSharp.fluid}
          />
        </Link>
      )*/}
    </GatsbyHero>
  );
};

export default SectionHeroImage;
